import React, { useEffect, useState } from "react";
import LeftArea from "./LeftArea";
import { useNavigate, useLocation } from "react-router-dom";
import Button from "./Button";
import Adim from "./Adim";
import Yetkinlikler from "./Yetkinlikler";
import { useDispatch, useSelector } from "react-redux";
import { saveKariyerData } from "../../redux/actions/index";
import InputYeni from "./InputYeni";
import { inputs } from "../../utils/constants";
import createSlug from "../../utils/slug";
import Positions from "./Positions";
import Checkbox from "./Checkbox";
const Kayit3 = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [skills, setSkills] = useState([]);
  const [positions, setPositions] = useState([]);
  const { loading, error } = useSelector((state) => state.auth);
  const { user } = useSelector((state) => state.user);
  const [formError, setFormError] = useState(null);
  const userName = user?.data?.name;
  const email = location.state?.email || "";
  const name = location.state?.name || "";

  useEffect(() => {
    if (userName && userName !== "null") {
      const userNameSlug = createSlug(userName);
      navigate(`/hesabim/${userNameSlug}`);
    }
  }, [userName, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError(null);
    const formData = new FormData(e.target);
    let userData = {
      email: email || "",
      type: formData.get("type"),
      position: positions[0] || "",
      skills: skills.length > 0 ? skills : [],
      contractofUse: formData.get("contractOfUse") === "true",
      privacyPolicy: formData.get("privacyPolicy") === "true",
      contentPolicy: formData.get("contentPolicy") === "true",
    };

    try {
      await dispatch(saveKariyerData(userData)).unwrap();
    } catch (error) {
      // error'un string olduğundan emin olalım
      const errorMessage =
        typeof error === "string"
          ? error
          : error.message || "Kayıt işlemi başarısız. Lütfen tekrar deneyin.";
      setFormError(errorMessage);
    }
  };

  return (
    <div className="containerMain grid items-start grid-cols-1 xl:grid-cols-2 gap-20 xl:gap-2 justify-between mx-auto place-items-center h-auto my-28">
      <LeftArea />
      <div className="rightArea">
        <form className="form-container" onSubmit={handleSubmit}>
          <InputYeni page="kariyer_bilgileri" inputs={inputs} />
          <Positions positions={positions} setPositions={setPositions} />
          <Yetkinlikler skills={skills} setSkills={setSkills} />
          <Checkbox userName={name} email={email} />
          <Button page="kariyer_bilgileri" loading={loading} />
          <Adim page="kariyer_bilgileri" />
        </form>
        {formError && <p className="text-red-500">{formError}</p>}
      </div>
    </div>
  );
};

export default Kayit3;
